import { InfoCircle } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";

interface SmartCollabGroupBadgeProps {
  className?: string;
  showLabel?: boolean;
}

/**
 * Badge shown on the group detail header for a real smart_collab_groups (v2) group — same shape
 * as SmartUnboxGroupBadge, but that one's copy describes the legacy hash-grouping mechanism, not
 * this one's deliberate, persisted grouping. Same wording already used on SmartGroupCard.
 */
export const SmartCollabGroupBadge = ({ className, showLabel = true }: SmartCollabGroupBadgeProps) => {
  return (
    <span className={`inline-flex items-center gap-1 text-xs text-tertiary ${className ?? ""}`}>
      {showLabel && <span>Smart Collab Group</span>}
      <Tooltip
        title="Smart Collab Group"
        description="A group of collaborations created together, sharing the same products, commission rates, and sample settings. Click the row to expand and see individual collaborations."
        placement="top"
      >
        <TooltipTrigger className="inline-flex items-center">
          <InfoCircle className="w-4 h-4 text-quaternary hover:text-tertiary cursor-help transition-colors" />
        </TooltipTrigger>
      </Tooltip>
    </span>
  );
};
